import { useCallback } from 'react';

import { useQueryCriteriasState } from '../query/useQueryCriteriasState';
import { EditableCriteria } from '../../types';
import { useCurrentCriteriaIndex } from './useCurrentCriteriaIndex';

export const useCriteriaState = () => {
  const { criterias, setCriterias } = useQueryCriteriasState();
  const index = useCurrentCriteriaIndex();
  const criteria = criterias[index];
  const setCriteria = useCallback(
    (setterFn: (currentCriteria: EditableCriteria) => EditableCriteria) =>
      setCriterias((currentCriterias) =>
        currentCriterias.map((currentCriteria, i) =>
          i === index ? setterFn(currentCriteria) : currentCriteria,
        ),
      ),
    [setCriterias, index],
  );
  return { criteria, setCriteria };
};
